import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import Avatar from 'react-avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';
import * as ROUTES from '../../../constants/routes';
import ModalConfirm from '../../useful/ModalConfirm';
import { withRouter } from 'react-router-dom';

const PremiumUserItem = (props) => {

    const [deleting, setDeleting] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '' });
    const user = props.user;

    const deleteUser = () => {
        setConfirmModal({ show: false, title: '', message: '' })
        if (user.uid) {
            setDeleting(true);
            const deleteUserFuntion = props.firebase.deleteUser();

            deleteUserFuntion({ uid: user.uid })
                .then((result) => {
                    setDeleting(false);
                    if (result.data && result.data.code && result.data.code === 200) {
                        props.showModal("Info", "El usuario se eliminó con éxito");
                    } else {
                        props.showModal("Error", "No se pudo eliminar el usuario");
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setDeleting(false);
                    props.showModal("Error", "No se pudo eliminar el usuario");
                });
        }

    }

    const openUser = () => {
        props.history.push(ROUTES.USER_TOURNAMENTS(user.uid))
    }

    const showConfirmModal = () => {
        setConfirmModal({ show: true, title: 'Eliminar usuario', message: 'Está seguro de eliminar el usurario: ' + user.email });
    }

    const userName = user && user.email ?
        user.email.substring(0, user.email.indexOf('@'))
        :
        "";
    const userDomain = user && user.email ?
        user.email.substring(user.email.indexOf('@'), user.email.length)
        :
        "";

    const color = user && user.blocked ? '#f88b97' : '#87f892';

    return (

        <tr className="bg-hover-td">
            {/* <td className="align-middle text-center" onClick={openTeam} scope="row" >{index}</td> */}
            <td className="align-middle text-right" onClick={openUser} >
                <Avatar textSizeRatio={1.7} className="align-self-center text-dark mr-0" maxInitials={2} name={user.email} size="30" round={true} color={color} />
            </td>
            <td className="align-middle" onClick={openUser} >
                <span className="font-weight-bold">{userName}</span>
                <span className="d-block text-secondary font-weight-normal small">{userDomain}</span>
            </td>
            <td className="align-middle text-center text-nowrap" onClick={openUser} >{(user.tournamentsCount || '0') + '/' + user.tournaments}</td>
            <th className="align-middle">
                <div className="nav justify-content-end">
                    {(!deleting) ?
                        <button onClick={showConfirmModal} className="btn btn btn-link text-danger p-2 m-0" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                        :
                        <Loader className="m-1"
                            type="ThreeDots"
                            color="#263238"
                            height={30}
                            width={40}
                            timeout={0} />
                    }
                </div>
            </th>

            <ModalConfirm
                data={confirmModal}
                onClose={() => setConfirmModal({ show: false, title: '', message: '' })}
                onConfirm={deleteUser}
            />

        </tr >

    )


}

export default withRouter(withFirebase(PremiumUserItem));
